export default __webpack_public_path__ + "static/CaptureLeadsFromanyPlatform-50d4079219d3cf3f1d1c56d488bf3c1b.svg";